var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconAutoLoan = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9095_20698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2241 14.6222L21.7576 14.0003L21.3698 11.6717C21.2922 11.2045 21.0512 10.7801 20.6898 10.4739C20.3285 10.1678 19.8702 9.99986 19.3966 10H14.1176C13.6441 10.0001 13.186 10.1681 12.8249 10.4742C12.4637 10.7803 12.2228 11.2047 12.1452 11.6717L11.7574 14.0003L11.291 14.6222C10.9447 15.0837 10.7574 15.6451 10.7571 16.2221V20.0003C10.7573 20.1769 10.8276 20.3463 10.9525 20.4712C11.0774 20.5961 11.2467 20.6663 11.4234 20.6666H22.0908C22.2674 20.6663 22.4368 20.5961 22.5617 20.4712C22.6866 20.3463 22.7569 20.1769 22.7571 20.0003V16.2221C22.757 15.6452 22.5699 15.0839 22.2241 14.6222Z",
    fill: "#E2E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1534 17.6879C20.6252 17.6879 21.0076 17.3055 21.0076 16.8337C21.0076 16.3619 20.6252 15.9795 20.1534 15.9795C19.6816 15.9795 19.2992 16.3619 19.2992 16.8337C19.2992 17.3055 19.6816 17.6879 20.1534 17.6879Z",
    fill: "#6C7DE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3197 17.6879C13.7914 17.6879 14.1739 17.3055 14.1739 16.8337C14.1739 16.3619 13.7914 15.9795 13.3197 15.9795C12.8479 15.9795 12.4655 16.3619 12.4655 16.8337C12.4655 17.3055 12.8479 17.6879 13.3197 17.6879Z",
    fill: "#6C7DE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0909 20.6667H20.7574V21.3329C20.7577 21.5096 20.8279 21.6789 20.9528 21.8038C21.0778 21.9287 21.2471 21.999 21.4237 21.9992H22.09C22.2667 21.999 22.436 21.9287 22.5609 21.8038C22.6858 21.6789 22.7561 21.5096 22.7563 21.3329V20.0004C22.7561 20.1769 22.6859 20.3461 22.5612 20.471C22.4365 20.5958 22.2674 20.6662 22.0909 20.6667Z",
    fill: "#B6C1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4234 20.6667H12.7568V21.3329C12.7566 21.5096 12.6863 21.6789 12.5614 21.8038C12.4365 21.9287 12.2671 21.999 12.0905 21.9992H11.4234C11.2467 21.999 11.0774 21.9287 10.9525 21.8038C10.8276 21.6789 10.7573 21.5096 10.7571 21.3329V20.0004C10.7573 20.177 10.8276 20.3463 10.9525 20.4713C11.0774 20.5962 11.2467 20.6664 11.4234 20.6667Z",
    fill: "#B6C1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3588 18.0005H15.6936C15.517 18.0007 15.3476 18.071 15.2227 18.1959C15.0978 18.3208 15.0276 18.4901 15.0273 18.6668C15.0276 18.8434 15.0978 19.0128 15.2227 19.1377C15.3476 19.2626 15.517 19.3328 15.6936 19.3331H18.3588C18.5354 19.3328 18.7048 19.2626 18.8297 19.1377C18.9546 19.0128 19.0248 18.8434 19.0251 18.6668C19.0248 18.4901 18.9546 18.3208 18.8297 18.1959C18.7048 18.071 18.5354 18.0007 18.3588 18.0005Z",
    fill: "#6C7DE5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9095_20698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.75708)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconAutoLoan);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_auto_loan.e4b2e21004c1440ae2636a7201e208a5.svg";